import { useEffect, useState } from "react";
import { BsPeople } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormWebhooks from "../FormWebhooks/FormWebhooks";
import ListWebhooks from "../ListWebhooks/ListWebhooks";
import "./ConsultaWebhooks.css";
import { MdWebhook } from "react-icons/md";

const ConsultaWebhooks = () => {
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<MdWebhook size={20} />}
					title="Webhooks"
					navigate="../cadastro-webhooks"
					buttonLabel="Adicionar Webhook"
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListWebhooks filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormWebhooks webhook={lineSelected} type="consulta" />
			</ConsultaFormContainer>
		</div>
	);
};

export default ConsultaWebhooks;
